import { show as showError } from './error-toast.js';

const MAX_CART_QTY = 50;
const MONEY_FORMAT = window.__CART_CONFIG__.moneyFormat;

function formatMoney(cents) {
  const amount = (cents / 100).toFixed(2);
  return MONEY_FORMAT
    .replace('{{amount}}', amount)
    .replace('{{amount_no_decimals}}', Math.round(cents / 100).toString())
    .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
    .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100).toString());
}

const pending = new Map();
let active = false;

async function flushQueue() {
  if (active) return;
  active = true;

  while (pending.size > 0) {
    const [key, quantity] = pending.entries().next().value;
    pending.delete(key);

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });

      if (quantity === 0) {
        location.reload();
        return;
      }

      const text = await res.text();
      let cart;
      try { cart = JSON.parse(text); } catch { location.reload(); return; }

      if (!res.ok) {
        const msg = cart.description || cart.message || 'Something went wrong updating your cart.';
        showError(msg.toUpperCase());
        const actual = await fetch('/cart.js').then(r => r.json()).catch(() => null);
        if (actual?.items) {
          const actualItem = actual.items.find(i => i.key === key);
          const input = document.querySelector(`.cart-item[data-key="${key}"] .cart-item__qty-input`);
          if (input && actualItem) {
            input.value = actualItem.quantity;
            input.dataset.prev = actualItem.quantity;
          }
        }
        continue;
      }

      document.getElementById('cart-total-price').textContent = formatMoney(cart.total_price);

      const updatedItem = cart.items.find(i => i.key === key);
      const lineEl = document.querySelector(`[data-line-price="${key}"]`);
      if (lineEl) lineEl.textContent = updatedItem ? formatMoney(updatedItem.line_price) : formatMoney(0);
    } catch (err) {
      showError('CONNECTION ERROR. PLEASE TRY AGAIN.');
    }
  }

  active = false;
}

const debounceTimers = new Map();

function updateCart(key, quantity) {
  pending.set(key, quantity);
  clearTimeout(debounceTimers.get(key));
  debounceTimers.set(key, setTimeout(() => {
    debounceTimers.delete(key);
    flushQueue();
  }, 400));
}

function getTotalQtyExcluding(excludeKey) {
  let total = 0;
  document.querySelectorAll('.cart-item__qty-input').forEach(input => {
    const key = input.closest('.cart-item').dataset.key;
    if (key !== excludeKey) total += parseInt(input.value) || 0;
  });
  return total;
}

function syncIncButtons() {
  let total = 0;
  document.querySelectorAll('.cart-item__qty-input').forEach(input => {
    total += parseInt(input.value) || 0;
  });
  document.querySelectorAll('.qty-btn[data-dir="1"]').forEach(btn => {
    btn.disabled = total >= MAX_CART_QTY;
  });
}

document.querySelectorAll('.qty-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const item = btn.closest('.cart-item');
    const input = document.getElementById(btn.dataset.target);
    const dir = parseInt(btn.dataset.dir);
    const currentVal = parseInt(input.value || 0);
    let newQty = Math.max(0, currentVal + dir);

    // Check max cart qty
    if (dir > 0) {
      const othersTotal = getTotalQtyExcluding(item.dataset.key);
      if (othersTotal + newQty > MAX_CART_QTY) {
        showError(`CART CAPACITY REACHED. MAX ${MAX_CART_QTY} ITEMS.`);
        return;
      }
    }

    newQty = Math.min(newQty, MAX_CART_QTY);
    input.value = newQty;
    input.dataset.prev = newQty;
    updateCart(item.dataset.key, newQty);
    syncIncButtons();
  });
});

document.querySelectorAll('.cart-item__qty-input').forEach(input => {
  input.setAttribute('max', MAX_CART_QTY);
  input.setAttribute('maxlength', '2');
  input.dataset.prev = input.value;

  // Enforce max 2 digits on input
  input.addEventListener('input', () => {
    input.value = input.value.replace(/\D/g, '').slice(0, 2);
  });

  input.addEventListener('change', () => {
    const parsed = parseInt(input.value);
    if (!input.value.trim() || isNaN(parsed) || parsed < 1) {
      input.value = input.dataset.prev;
      return;
    }

    const item = input.closest('.cart-item');
    const othersTotal = getTotalQtyExcluding(item.dataset.key);
    const clamped = Math.min(parsed, MAX_CART_QTY);

    if (parsed > MAX_CART_QTY) {
      showError(`MAX QUANTITY IS ${MAX_CART_QTY}.`);
    }

    if (othersTotal + clamped > MAX_CART_QTY) {
      const room = MAX_CART_QTY - othersTotal;
      if (room <= 0) {
        showError(`CART CAPACITY REACHED. MAX ${MAX_CART_QTY} ITEMS.`);
        input.value = input.dataset.prev;
        return;
      }
      input.value = room;
      showError(`CAPPED TO ${room}. MAX ${MAX_CART_QTY} ITEMS TOTAL.`);
    } else {
      input.value = clamped;
    }

    input.dataset.prev = input.value;
    updateCart(item.dataset.key, parseInt(input.value));
    syncIncButtons();
  });
});

syncIncButtons();
